var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tr",
    { staticClass: "grid grid-cols-2 grid-flow-row md:table-row" },
    [
      _c(
        "td",
        {
          staticClass:
            "md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
        },
        [_vm._v(" Customer ")]
      ),
      _c(
        "td",
        {
          staticClass:
            "px-1 md:px-1 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
        },
        [
          _c(
            "a",
            {
              staticClass: "text-blue-500 cursor-pointer",
              on: {
                click: function($event) {
                  return _vm.$emit(
                    "openCustomerInfo",
                    _vm.checkout.customer.phoneNumber
                  )
                }
              }
            },
            [
              _vm._v(
                _vm._s(_vm.checkout.customer.firstName) +
                  " " +
                  _vm._s(_vm.checkout.customer.lastName)
              )
            ]
          )
        ]
      ),
      _c(
        "td",
        {
          staticClass:
            "md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
        },
        [_vm._v(" Created at ")]
      ),
      _c(
        "td",
        {
          staticClass:
            "px-1 md:px-1 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 text-gray-500"
        },
        [
          _vm._v(
            " " + _vm._s(_vm._f("dateFilter")(_vm.checkout.createdDate)) + " "
          )
        ]
      ),
      _c(
        "td",
        {
          staticClass:
            "md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
        },
        [_vm._v(" Recovery status ")]
      ),
      _c(
        "td",
        {
          staticClass:
            "px-1 md:px-1 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 text-gray-500"
        },
        [
          _c(
            "span",
            {
              staticClass:
                "px-2 inline-flex text-xs leading-5 font-normal rounded-full ",
              class: {
                "bg-red-100 text-red-800": !_vm.checkout.isRecovered,
                "bg-green-100 text-green-800": _vm.checkout.isRecovered
              }
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.checkout.isRecovered ? "recovered" : "Not recovered"
                  ) +
                  " "
              )
            ]
          )
        ]
      ),
      _c(
        "td",
        {
          staticClass:
            "md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
        },
        [_vm._v(" Message status ")]
      ),
      _c(
        "td",
        {
          staticClass:
            "px-1 md:px-1 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 text-gray-500"
        },
        [
          _c(
            "span",
            {
              staticClass:
                "px-2 inline-flex text-xs leading-5 font-normal rounded-full ",
              class: {
                "bg-red-100 text-red-800": !_vm.checkout.isMessageSent,
                "bg-green-100 text-green-800": _vm.checkout.isMessageSent
              }
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.checkout.isMessageSent ? "Sent" : "Not sent") +
                  " "
              )
            ]
          )
        ]
      ),
      _c(
        "td",
        {
          staticClass:
            "md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
        },
        [_vm._v(" Checkout Id ")]
      ),
      _c(
        "td",
        {
          staticClass:
            "px-1 md:px-1 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
        },
        [_vm._v(" " + _vm._s(_vm.checkout.checkoutId) + " ")]
      ),
      _c(
        "td",
        {
          staticClass:
            "md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
        },
        [_vm._v(" Total ")]
      ),
      _c(
        "td",
        {
          staticClass:
            "px-1 md:px-1 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
        },
        [
          _c("span", [
            _vm._v(
              _vm._s(_vm.checkout.currency) +
                " " +
                _vm._s(_vm.checkout.totalPrice)
            )
          ]),
          _c("br"),
          _vm.checkout.customerMeta && _vm.checkout.customerMeta.lastOrderTime
            ? _c("span", { staticClass: "text-gray-500" }, [
                _vm._v(
                  _vm._s(
                    _vm._f("dateFilter")(
                      _vm.checkout.customerMeta.lastOrderTime
                    )
                  )
                )
              ])
            : _vm._e()
        ]
      ),
      _c("td", {
        staticClass:
          "md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
      }),
      _c(
        "td",
        {
          staticClass:
            "px-1 md:px-1 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
        },
        [
          _c("div", { staticClass: "mt-2" }, [
            _vm.checkout.customerMeta &&
            _vm.checkout.customerMeta.shouldNotDisturb
              ? _c(
                  "span",
                  {
                    staticClass:
                      "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-indigo-100 text-indigo-800"
                  },
                  [
                    _vm._v(" Do not disturb "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "flex-shrink-0 ml-1.5 inline-flex text-indigo-500 focus:outline-none focus:text-indigo-700",
                        attrs: {
                          type: "button",
                          "aria-label": "Remove small badge"
                        },
                        on: {
                          click: function($event) {
                            return _vm.removeTag("shouldNotDisturb")
                          }
                        }
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "h-2 w-2",
                            attrs: {
                              stroke: "currentColor",
                              fill: "none",
                              viewBox: "0 0 8 8"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                "stroke-linecap": "round",
                                "stroke-width": "1.5",
                                d: "M1 1l6 6m0-6L1 7"
                              }
                            })
                          ]
                        )
                      ]
                    )
                  ]
                )
              : _vm._e(),
            _vm.checkout.customerMeta &&
            _vm.checkout.customerMeta.isNotOnWhatsapp
              ? _c(
                  "span",
                  {
                    staticClass:
                      "inline-flex mx-1 items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-indigo-100 text-indigo-800"
                  },
                  [
                    _vm._v(" Not on Whatsapp "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "flex-shrink-0 ml-1.5 inline-flex text-indigo-500 focus:outline-none focus:text-indigo-700",
                        attrs: {
                          type: "button",
                          "aria-label": "Remove small badge"
                        },
                        on: {
                          click: function($event) {
                            return _vm.removeTag("isNotOnWhatsapp")
                          }
                        }
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "h-2 w-2",
                            attrs: {
                              stroke: "currentColor",
                              fill: "none",
                              viewBox: "0 0 8 8"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                "stroke-linecap": "round",
                                "stroke-width": "1.5",
                                d: "M1 1l6 6m0-6L1 7"
                              }
                            })
                          ]
                        )
                      ]
                    )
                  ]
                )
              : _vm._e()
          ]),
          _c(
            "div",
            { staticClass: "mt-2" },
            [_c("AddTagDropdown", { on: { onItemClicked: _vm.addTag } })],
            1
          )
        ]
      ),
      _c(
        "td",
        {
          staticClass:
            "px-1 md:px-1 py-2 md:py-4 whitespace-no-wrap text-right border-b border-gray-200 text-xs leading-5 font-medium"
        },
        [_c("SendMessageDropdown", { attrs: { checkout: _vm.checkout } })],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }